export const setJumpConsent = async () => {
    const _url = "/users/setConsent";
    const payload = {
        type: "jumpToBidd",
        consent: true,
    };

    try {
        const response = await fetch(`${process.env.API_BASE_URL}${_url}`, {
            method: "POST",
            credentials: "include",
            headers: {
                "x-web-version": "1.10.3",
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error("Failed to set consent");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error setting consent1:", error);
        throw error;
    }
};

export const getBiddUrl = async () => {
    const url = `/users/jump?url=${process.env.API_BIDD_BASE_URL}&pid=40&partner=biddeasy&source=incredmoney`;
    try {
        const response = await fetch(`${process.env.API_BASE_URL}`+url, {
            method: "GET",
            headers: {
                "X-product": `orobonds:default`,
                "Content-Type": "application/json",
                "x-web-version": "1.10.3",
            },
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const jumpToBiddUrl = async (url: string) => {
    console.log("#url: ", url);
    
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "flag": "jump-to-bidd"
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.data.token;
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};
